import React, { Component, useEffect, useState } from 'react';
import { Localize } from '../modules/localize/Localize';
import TabMenuButton from './control/TabMenuButton';

/**
 * @deprecated use hook version instead
 */
export default class TabMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currSelectedTab: 0,
        }
    }

    onItemSelected(type, item) {
        console.log(type, item);
        if (this.state.currSelectedTab != type) {
            this.setState({ currSelectedTab: type })
            if (this.props.onItemChanged != null) {
                this.props.onItemChanged(type, item);
            }
        }
    }

    render() {
        let btns = [];
        let { tabItems, className } = this.props;
        if (tabItems != null)
            tabItems.forEach(item => {
                const btn = <TabMenuButton
                    key={item.type}
                    type={item.type}
                    name={item.name}
                    selected={this.state.currSelectedTab == item.type}
                    onSelected={(type, name) => this.onItemSelected(type, item)}
                />
                btns.push(btn);
            });

        return (
            <div className={'pl-5 pr-5 flex text-md ' + className}>
                {btns}
            </div>
        );
    }

}

/**
 * 
 * @param {Array} tabItems 
 * @param {Function} onItemChanged 
 * @param {Number} currSelTab 
 * @param {String} className 
 * @returns 
 */
export const TabMenu2 = ({ tabItems, onItemChanged, currSelTab, className, isSelectedItem }) => {

    const [tabSelected, setTabSelected] = useState(currSelTab);

    let g = isSelectedItem;
    if (g == null) {
        g = (currSel, item) => currSel == item.type;
    }

    useEffect(() => {
        setTabSelected(currSelTab);
    }, [currSelTab])

    const onItemSelected = (type, item) => {
        console.log(type, item);
        if (tabSelected.type != type) {
            setTabSelected(item.type);
            if (onItemChanged != null) {
                onItemChanged(type, item);
            }
        }
    }

    let btns = [];
    if (tabItems != null)
        tabItems.forEach(item => {

            if(item.name.startsWith("L:")){
                item.name = item.name.slice(2);
                item.name = Localize.getMsgByPath(item.name);
            }

            const btn = <TabMenuButton
                key={item.type}
                type={item.type}
                name={item.name}
                selected={g(tabSelected, item)}
                onSelected={(type, name) => onItemSelected(type, item)}
            />
            btns.push(btn);
        });

    return <div className={'pl-5 pr-5 flex text-md ' + className}>
        {btns}
    </div>

}